/**
 * Whole bags or bottles needed to hold `total` when each holds `size`.
 *
 * Label rates and bag weights are printed rounded (Scotts Weed & Feed: 2.86 lb
 * per 1,000 sq ft, 14.29 lb bag "covers 5,000 sq ft"), so the exact ratio for
 * the area a bag is sold for lands a hair over a whole number (1.0007). The
 * ratio is rounded to 2 decimals before the ceiling: an overage under half a
 * percent of one container is label rounding, not a real shortfall. Any
 * positive amount needs at least one container.
 */
export function wholeContainers(total: number, size: number): number {
  if (!(total > 0) || !(size > 0)) return 0
  return Math.max(1, Math.ceil(Math.round((total / size) * 100) / 100))
}
